import React from "react";

type props = {
  children?: React.ReactNode;
};
const Button = (props: props) => {
  const { children } = props;
  return (
    <button onClick={() => console.log("Greeting from liberary")}>
      {children || "hi"}
    </button>
  );
};

export default Button;
